import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { hippoResourceAtom } from '../recoil/atoms/hippoResourceAtom';

const useHippoText = (): ((
    resourceKey: string,
    replaceTexts?: Record<string, string | number>
) => string) => {
    const hippoResource = useRecoilValue(hippoResourceAtom);

    const getHippoText = useCallback(
        (resourceKey: string, replaceTexts?: Record<string, string | number>) => {
            let hippoText = hippoResource[resourceKey] ?? resourceKey;
            if (!replaceTexts) {
                return hippoText;
            }

            Object.entries(replaceTexts).forEach(([key, value]) => {
                if (value !== undefined)
                    hippoText = hippoText.replaceAll(`<${key}>`, String(value));
            });

            return hippoText;
        },
        [hippoResource]
    );

    return getHippoText;
};

export { useHippoText };
